import { render, staticRenderFns } from "./DeadChicks.vue?vue&type=template&id=2d3eac3c&scoped=true"
import script from "./DeadChicks.vue?vue&type=script&lang=js"
export * from "./DeadChicks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3eac3c",
  null
  
)

export default component.exports